/**
 * Calendar-day difference from a to b, using local date components projected
 * onto UTC so that DST offsets never skew the result.
 * Returns a negative number if a > b.
 */
export function calendarDayDiff(a: Date, b: Date): number {
    const utcA = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    const utcB = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    return Math.round((utcB - utcA) / 86400000);
}
